<template>
  <div
    id="addModal"
    class="modal fade bd-example-modal-xl"
    tabindex="-1"
    role="dialog"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 style="font-size: 18px !important">
            Agregar nueva plantilla de certificado
          </h5>
          <button class="btn-close" type="button" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="container mt-4">
            <form @submit.prevent="handleSubmit">
              <ul class="list-group">
                <li class="list-group-item">
                  <div class="row">
                    <div class="col-4 bg-light text-dark py-2">
                      Nombre Plantilla
                    </div>
                    <div class="col-8 bg-white text-dark py-2">
                      <input
                        type="text"
                        class="form-control"
                        v-model="templateName"
                      />
                    </div>
                  </div>
                </li>
                <li class="list-group-item">
                  <div class="row">
                    <div class="col-4 bg-light text-dark py-2">Plantilla</div>
                    <div class="col-8 bg-white text-dark py-2">
                      <input
                        class="form-control"
                        type="file"
                        id="fileInput"
                        @change="handleFileChange"
                        accept=".docx"
                        required
                      />
                    </div>
                  </div>
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="handleSubmit">
            Registrar
          </button>
          <button type="button" class="btn btn-default" @click="closeModal">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject } from "vue";

const swal = inject("$swal");
const emits = defineEmits(["refresh", "reload"]);
import axios from "@/includes/connection";
import { toast } from "vue3-toastify";

const templateName = ref("");
const file = ref(null);

const handleFileChange = (event) => {
  const selectedFile = event.target.files[0];
  if (
    selectedFile &&
    selectedFile.type ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ) {
    file.value = selectedFile;
  } else {
    file.value = null;
  }
};

const handleSubmit = async () => {
  if (!file.value) {
    toast.warning("Archivo no valido!!!");
    return;
  }

  const formData = new FormData();
  formData.append("templateName", templateName.value);
  formData.append("eventId", routeId);
  formData.append("file", file.value);

  try {
    const response = await axios.post(
      "/certification/upload-template",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    //console.log("Response:", response.data);
    templateName.value = "";
    file.value = null;
    emits("reload");
  } catch (error) {
    console.error("Error uploading file:", error);
  }
};

//section
const closeModal = () => {
  emits("reload");
};

//-----route section
import { useRoute } from "vue-router";

const route = useRoute();

// Access the route parameter
const routeId = route.params.id;
</script>
